(function () {
  'use strict';

  // Repli si les métaobjets n'exposent pas de position ; sinon l'ordre vient de quiz_family.position (DOM).
  var FAMILY_TIE_ORDER = ['floral', 'frais', 'gourmand', 'ambres', 'boise', 'fruite'];
  // Couche intensité "douce" : mappe la réponse d'intensité vers les valeurs custom.intensity (1-5) acceptées.
  var INTENSITY_MAP = { legere: [1, 2], moderee: [3], presente: [4], intense: [5] };
  var STORAGE_KEYS = ['adshop:quiz', 'adshop:quiz:answers', 'adshop:quiz:step', 'adshop:quiz:family'];

  function clearPersistedState() {
    try {
      STORAGE_KEYS.forEach(function (key) {
        if (window.localStorage) window.localStorage.removeItem(key);
        if (window.sessionStorage) window.sessionStorage.removeItem(key);
      });
    } catch (e) {
      /* storage may be unavailable in private mode */
    }
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function Quiz(root) {
    this.root = root;
    this.steps = {};
    this.totalQuestions = 0;
    this.currentStep = 'intro';
    this.answers = [];
    this.intensity = null;
    this.transitioning = false;
    this.familyData = {};

    this.collectSteps();
    this.collectFamilyData();
    this.bindEvents();
    // Démarre DIRECTEMENT sur la 1re question (plus d'écran intro/« Démarrer »).
    this.show(this.steps['1'] ? '1' : 'intro', { skipAnimation: true });
  }

  Quiz.prototype.collectSteps = function () {
    var nodes = this.root.querySelectorAll('[data-quiz-step]');
    var self = this;
    nodes.forEach(function (node) {
      var key = node.getAttribute('data-quiz-step');
      self.steps[key] = node;
      var idx = parseInt(key, 10);
      if (!isNaN(idx) && idx > self.totalQuestions) self.totalQuestions = idx;
    });
  };

  Quiz.prototype.collectFamilyData = function () {
    var nodes = this.root.querySelectorAll('.quiz__families-data [data-family]');
    var self = this;
    var slugs = [];
    nodes.forEach(function (node) {
      var slug = node.getAttribute('data-family');
      var posAttr = node.getAttribute('data-family-position');
      var pos = posAttr ? parseInt(posAttr, 10) : NaN;
      self.familyData[slug] = {
        name: node.getAttribute('data-family-name') || '',
        description: node.getAttribute('data-family-description') || '',
        image: node.getAttribute('data-family-image') || '',
        kitHref: node.getAttribute('data-family-kit-href') || '',
        position: isNaN(pos) ? 999 : pos
      };
      slugs.push(slug);
    });
    // Ordre de tie-break piloté par les métaobjets (position asc) ; repli sur l'ordre codé en dur.
    var ordered = slugs.filter(function (s) { return self.familyData[s].position < 999; });
    if (ordered.length) {
      ordered.sort(function (a, b) { return self.familyData[a].position - self.familyData[b].position; });
      this.tieOrder = ordered;
    } else {
      this.tieOrder = FAMILY_TIE_ORDER.slice();
    }
  };

  Quiz.prototype.bindEvents = function () {
    var self = this;

    this.root.addEventListener('click', function (e) {
      var startBtn = e.target.closest('[data-quiz-start]');
      if (startBtn) {
        e.preventDefault();
        self.start();
        return;
      }

      var answerBtn = e.target.closest('[data-quiz-answer]');
      if (answerBtn) {
        e.preventDefault();
        self.answer(answerBtn);
        return;
      }

      var prevBtn = e.target.closest('[data-quiz-prev]');
      if (prevBtn) {
        e.preventDefault();
        self.prev();
        return;
      }

      var skipBtn = e.target.closest('[data-quiz-skip-optin]');
      if (skipBtn) {
        e.preventDefault();
        self.show('results');
        return;
      }

      var restartBtn = e.target.closest('[data-quiz-restart]');
      if (restartBtn) {
        e.preventDefault();
        self.restart();
        return;
      }
    });

    var form = this.root.querySelector('.quiz__optin-form');
    if (form) {
      form.addEventListener('submit', function () {
        var noteField = form.querySelector('[data-quiz-form-note]');
        if (noteField) {
          noteField.value = JSON.stringify({
            answers: self.answers,
            intensity: self.intensity,
            family: self.computeFamily()
          });
        }
        var tagsField = form.querySelector('[data-quiz-form-tags]');
        if (tagsField) {
          var family = self.computeFamily();
          tagsField.value = 'quiz-completed, family-' + (family || 'unknown');
        }
      });
    }

    this.bindSwipe();
  };

  Quiz.prototype.bindSwipe = function () {
    var self = this;
    var startX = null;
    var startY = null;
    var pointerActive = false;
    var threshold = 60;

    this.root.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'touch') return;
      if (e.target.closest('button, a, input, textarea, label, select')) return;
      pointerActive = true;
      startX = e.clientX;
      startY = e.clientY;
    });

    this.root.addEventListener('pointerup', function (e) {
      if (!pointerActive) return;
      pointerActive = false;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      if (Math.abs(dx) < threshold || Math.abs(dx) < Math.abs(dy)) return;
      var idx = parseInt(self.currentStep, 10);
      if (isNaN(idx)) return;
      if (dx < 0) {
        /* swipe left = next: only if answer recorded */
        return;
      } else {
        if (idx > 1) self.prev();
      }
    });

    this.root.addEventListener('pointercancel', function () {
      pointerActive = false;
    });
  };

  Quiz.prototype.start = function () {
    this.show('1');
  };

  Quiz.prototype.answer = function (btn) {
    if (this.transitioning) return;
    var family = btn.getAttribute('data-family');
    var intensity = btn.getAttribute('data-intensity');
    var step = parseInt(btn.getAttribute('data-step'), 10);
    if (isNaN(step)) return;

    if (family) {
      this.answers[step - 1] = family;
      this.answers = this.answers.slice(0, step);
    } else if (intensity) {
      this.intensity = intensity;
    } else {
      return;
    }

    if (step < this.totalQuestions) {
      this.show(String(step + 1));
    } else {
      this.show('results');
    }
  };

  Quiz.prototype.prev = function () {
    var idx = parseInt(this.currentStep, 10);
    if (isNaN(idx)) {
      if (this.currentStep === 'optin') {
        this.show(String(this.totalQuestions));
      }
      return;
    }
    if (idx > 1) {
      this.answers = this.answers.slice(0, idx - 1);
      this.show(String(idx - 1));
    }
  };

  Quiz.prototype.restart = function () {
    this.answers = [];
    this.intensity = null;
    this.show(this.steps['1'] ? '1' : 'intro');
  };

  Quiz.prototype.computeFamily = function () {
    if (!this.answers.length) return null;
    var order = (this.tieOrder && this.tieOrder.length) ? this.tieOrder : FAMILY_TIE_ORDER;
    var scores = {};
    this.answers.forEach(function (fam) {
      if (!fam) return;
      scores[fam] = (scores[fam] || 0) + 1;
    });
    var entries = Object.keys(scores).map(function (k) { return [k, scores[k]]; });
    if (!entries.length) return null;
    entries.sort(function (a, b) {
      if (b[1] !== a[1]) return b[1] - a[1];
      var ia = order.indexOf(a[0]); if (ia === -1) ia = 999;
      var ib = order.indexOf(b[0]); if (ib === -1) ib = 999;
      return ia - ib;
    });
    return entries[0][0];
  };

  Quiz.prototype.show = function (key, opts) {
    var self = this;
    opts = opts || {};
    var nextEl = this.steps[key];
    if (!nextEl) return;
    var current = this.steps[this.currentStep];
    var sameStep = current === nextEl;

    var doSwitch = function () {
      Object.keys(self.steps).forEach(function (k) {
        var el = self.steps[k];
        el.hidden = (el !== nextEl);
        el.classList.remove('is-leaving', 'is-entering', 'is-entered');
      });
      self.currentStep = key;

      if (key === 'results') self.renderResults();
      if (opts.skipAnimation || prefersReducedMotion()) {
        nextEl.classList.add('is-entered');
        return;
      }
      nextEl.classList.add('is-entering');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          nextEl.classList.remove('is-entering');
          nextEl.classList.add('is-entered');
        });
      });

      try {
        self.root.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
      } catch (e) {
        self.root.scrollIntoView();
      }

      var focusTarget = nextEl.querySelector('h1, h2, [data-quiz-start], [data-quiz-answer], input[type="email"]');
      if (focusTarget && typeof focusTarget.focus === 'function') {
        try { focusTarget.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
      }
    };

    if (sameStep || opts.skipAnimation || prefersReducedMotion() || !current) {
      doSwitch();
      return;
    }

    this.transitioning = true;
    current.classList.remove('is-entered', 'is-entering');
    current.classList.add('is-leaving');

    var done = false;
    var finish = function () {
      if (done) return;
      done = true;
      doSwitch();
      self.transitioning = false;
    };
    setTimeout(finish, 220);
  };

  Quiz.prototype.renderResults = function () {
    var family = this.computeFamily();
    var nameEl = this.root.querySelector('[data-quiz-family-name]');
    var descEl = this.root.querySelector('[data-quiz-family-description]');
    var kitCta = this.root.querySelector('[data-quiz-kit-cta]');

    var data = family ? this.familyData[family] : null;
    if (nameEl) {
      nameEl.textContent = data ? data.name : '—';
      if (!prefersReducedMotion()) {
        nameEl.classList.remove('is-revealed');
        nameEl.classList.add('is-revealing');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            nameEl.classList.remove('is-revealing');
            nameEl.classList.add('is-revealed');
          });
        });
      } else {
        nameEl.classList.add('is-revealed');
      }
    }
    if (descEl) descEl.textContent = data ? data.description : '';

    // Image de la famille gagnante (result_image, ERP) : révélée si présente, sinon masquée
    var mediaEl = this.root.querySelector('[data-quiz-family-media]');
    var imgEl = this.root.querySelector('[data-quiz-family-image]');
    if (mediaEl && imgEl) {
      var imgUrl = data && data.image ? data.image : '';
      if (imgUrl) {
        imgEl.setAttribute('src', imgUrl);
        imgEl.setAttribute('alt', data.name || '');
        mediaEl.hidden = false;
      } else {
        mediaEl.hidden = true;
        imgEl.removeAttribute('src');
      }
    }

    if (kitCta && data && data.kitHref) kitCta.setAttribute('href', data.kitHref);

    var pools = this.root.querySelectorAll('[data-family-products]');
    var self = this;
    pools.forEach(function (pool) {
      var isWinner = pool.getAttribute('data-family-products') === family;
      pool.hidden = !isWinner;
      if (isWinner) self.applyIntensityFilter(pool);
    });
  };

  // Couche intensité "douce" : privilégie les produits de l'intensité choisie, MAIS ne vide
  // jamais le pool. Si trop peu de produits correspondent (< 2), on affiche tout (repli).
  // Tant que custom.intensity est uniforme, le filtre est neutre (aucun ou tous correspondent).
  Quiz.prototype.applyIntensityFilter = function (pool) {
    var items = pool.querySelectorAll('.quiz__product-item');
    if (!items.length) return;
    items.forEach(function (it) { it.style.display = ''; });

    var targets = this.intensity ? INTENSITY_MAP[this.intensity] : null;
    if (!targets || !targets.length) return;

    var matchCount = 0;
    items.forEach(function (it) {
      var v = parseInt(it.getAttribute('data-intensity'), 10);
      if (!isNaN(v) && targets.indexOf(v) !== -1) matchCount++;
    });
    if (matchCount < 2) return; // repli gracieux : pas assez de matches, on garde tout

    items.forEach(function (it) {
      var v = parseInt(it.getAttribute('data-intensity'), 10);
      if (isNaN(v) || targets.indexOf(v) === -1) it.style.display = 'none';
    });
  };

  function init() {
    clearPersistedState();
    var roots = document.querySelectorAll('[data-quiz]');
    roots.forEach(function (root) {
      if (root.__quizInstance) return;
      root.__quizInstance = new Quiz(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
